import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Button } from 'antd';

import Alert from 'components/Alert/Alert';
import HTMLText from 'components/HTMLText/HTMLText';
import {
  formatInterviewSlotDateForDisplay,
  formatInterviewSlotTimeForDisplay
} from 'components/InterviewScheduler/utils/interviewSlotFormatting';

import { selectAppLocale } from 'features/locale/localeSelectors';

import { GTMEventLogger } from 'utils/analytics';

import { InterviewDetails } from 'types/interviewSlots';

import { AlertType, GTMEvents } from 'constants/enums';

import styles from './InterviewScheduled.module.scss';

interface InterviewScheduledProps {
  interviewDetails: InterviewDetails;
}

const InterviewScheduled: FC<InterviewScheduledProps> = ({
  interviewDetails
}) => {
  const { t } = useTranslation();
  const appLocale = useSelector(selectAppLocale);

  const slotStart = interviewDetails?.slots.slotList[0].start;

  const interviewDate = formatInterviewSlotDateForDisplay(slotStart, appLocale);
  const interviewTime = formatInterviewSlotTimeForDisplay(slotStart, appLocale);
  const interviewTimeZone = interviewDetails?.slots.timeZone;

  // TODO: Implement add to calendar
  const handleAddToCalendar = () => {};

  const handleJoinInterview = () => {
    GTMEventLogger(
      GTMEvents.ApplicationsListViewSidebarInterviewJoblioClickJoin
    );
    window.open(interviewDetails?.slots.hostLink, '_blank');
  };

  return (
    <>
      <div className={styles.title}>
        {t('sidebar.application.interview.scheduled.title')}
      </div>

      <Alert type={AlertType.Success} className={styles.successMessage}>
        <HTMLText
          text={t('sidebar.application.interview.scheduled.message', {
            name: interviewDetails?.application.jobseekerFullName
          })}
        />
      </Alert>

      <div className={styles.interviewDetails}>
        <div className={styles.detailRow}>
          <span className={styles.label}>
            {t('sidebar.application.interview.scheduled.dateNtime')}
          </span>
          <span className={styles.value}>
            {t('sidebar.application.interview.scheduled.at', {
              date: interviewDate,
              time: interviewTime,
              timeZone: interviewTimeZone
            })}
          </span>
        </div>

        <div className={styles.detailRow}>
          <span className={styles.label}>
            {t('sidebar.application.interview.scheduled.duration')}
          </span>
          <span className={styles.value}>
            {t('sidebar.application.interview.scheduled.60minutes')}
          </span>
        </div>

        <div className={styles.detailRow}>
          <span className={styles.label}>
            {t('sidebar.application.interview.scheduled.type')}
          </span>
          <span className={styles.value}>
            {t('sidebar.application.interview.scheduled.videoInterview')}
          </span>
        </div>
      </div>

      <div className={styles.actions}>
        {/* <Button
          type="default"
          icon={<CalendarIcon />}
          onClick={handleAddToCalendar}
          className={styles.actionButton}
        >
          Add to Calendar
        </Button> */}

        <Button
          type="primary"
          onClick={handleJoinInterview}
          className={styles.actionButton}
        >
          {t('sidebar.application.interview.scheduled.joinInterview')}
        </Button>
      </div>
    </>
  );
};

export default InterviewScheduled;
